import React from 'react';
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import { loginRedirect } from '../../services/auth';
import { usePermission } from '../../hooks/usePermission';

export interface RouteLayoutProps extends RouteProps {
    layout: React.ComponentType<any>;
    component: React.ComponentType<any>;
    isAuth?: boolean;
    allowedRoles?: string[];
}

const RouteLayout = (props: RouteLayoutProps): JSX.Element => {
    const token = localStorage.getItem('gov_access_token_sso');
    const { isAdminUserLoading } = useAuth();
    const { canAccess } = usePermission();
    const { pathname } = useLocation();
    const {
        layout: Layout,
        component: Component,
        path,
        isAuth,
        allowedRoles
    } = props;

    if (isAuth && !token) {
        loginRedirect(pathname);
    }

    if (!isAdminUserLoading && !canAccess(allowedRoles)) {
        return <Redirect to="/" />;
    }

    return (
        <Route
            path={path}
            render={(matchProps) => (
                <Layout>
                    <Component {...matchProps} />
                </Layout>
            )}
        />
    );
};

export default RouteLayout;
